export type InfotechBankIdType =
  | 'bankBU'
  | 'bankCT'
  | 'bankCU'
  | 'bankDG'
  | 'bankHN'
  | 'bankIB'
  | 'bankJB'
  | 'bankJJ'
  | 'bankKA'
  | 'bankKB'
  | 'bankKD'
  | 'bankKE'
  | 'bankKJ'
  | 'bankKK'
  | 'bankKN'
  | 'bankMG'
  | 'bankSC'
  | 'bankSH'
  | 'bankSU'
  | 'bankWR'
  | 'bankNH'
  | 'bankPO';

interface InfotechBankModel {
  bankName: string;
  bankId: InfotechBankIdType;
  bankIconFileName: string;
}

export const INFOTECH_BANK: InfotechBankModel[] = [
  { bankName: '국민은행', bankId: 'bankKB', bankIconFileName: 'logo_kb' },
  { bankName: '농협은행', bankId: 'bankNH', bankIconFileName: 'logo_nh' },
  { bankName: '신한은행', bankId: 'bankSH', bankIconFileName: 'logo_shinhan' },
  { bankName: '카카오뱅크', bankId: 'bankKA', bankIconFileName: 'logo_kakaobank' },
  { bankName: '기업은행', bankId: 'bankIB', bankIconFileName: 'logo_ibk' },
  { bankName: '우리은행', bankId: 'bankWR', bankIconFileName: 'logo_woori' },
  { bankName: 'KEB하나은행', bankId: 'bankHN', bankIconFileName: 'logo_hana' },
  { bankName: 'SC제일은행', bankId: 'bankSC', bankIconFileName: 'logo_standardchartered' },
  { bankName: '씨티은행', bankId: 'bankCT', bankIconFileName: 'logo_citi' },
  { bankName: '산업은행', bankId: 'bankKD', bankIconFileName: 'logo_kdb' },
  { bankName: '새마을금고', bankId: 'bankMG', bankIconFileName: 'logo_mg-saemaeulgeumgo' },
  { bankName: '우체국', bankId: 'bankPO', bankIconFileName: 'logo_koreapost' },
  { bankName: '신협', bankId: 'bankCU', bankIconFileName: 'logo_shinhyup' },
  { bankName: '수협은행', bankId: 'bankSU', bankIconFileName: 'logo_suhyup' },
  { bankName: 'iM뱅크(구 대구은행)', bankId: 'bankDG', bankIconFileName: 'logo_imbank' },
  { bankName: '부산은행', bankId: 'bankBU', bankIconFileName: 'logo_bnk' },
  { bankName: '경남은행', bankId: 'bankKN', bankIconFileName: 'logo_bnk' },
  { bankName: '광주은행', bankId: 'bankKJ', bankIconFileName: 'logo_jb' },
  { bankName: '전북은행', bankId: 'bankJB', bankIconFileName: 'logo_jb' },
  { bankName: '제주은행', bankId: 'bankJJ', bankIconFileName: 'logo_shinhan' }
];
